<script setup lang="ts">
import { useLegacyHttpClient } from "@/composables/compat/useLegacyHttpClient"
import { useNavbarState } from "@/stores"
import type { Ref } from "vue"
import { ref } from "vue"
/*─────────────────────────────────────┐
│   props                              │
└─────────────────────────────────────*/
/*─────────────────────────────────────┐
│   functions                          │
└─────────────────────────────────────*/
async function submit() {
    try {
        await http.post("/reset_password", {
            token: token.value,
            newPassword: newPassword.value,
            newPasswordRepeat: newPasswordRepeat.value,
        })
        success.value = true
    } catch {
        success.value = false
    }
}

/*─────────────────────────────────────┐
│   composables                        │
└─────────────────────────────────────*/
const navbarState = useNavbarState()
const http = useLegacyHttpClient()
/*─────────────────────────────────────┐
│   refs                               │
└─────────────────────────────────────*/
const token: Ref<any> = ref(null)
const newPassword: Ref<any> = ref(null)
const newPasswordRepeat: Ref<any> = ref(null)
const success: Ref<any> = ref(null)
/*─────────────────────────────────────┐
│   setup                              │
└─────────────────────────────────────*/
const queryParams = new URLSearchParams(window.location.search)
if (queryParams.has("resetPasswordToken")) {
    token.value = queryParams.get("resetPasswordToken")
}
</script>

<template>
    <form @submit.prevent="submit()">
        <div class="card-body">
            <h5 class="card-title">
                {{ $t("login.lost_password") }}
            </h5>
            <p class="text-justify" v-if="success === null">
                {{ $t("@app:registration.reset_password.set_new_password_prompt") }}
            </p>
            <div class="alert alert-success" v-if="success">
                {{ $t("@app:registration.reset_password.success") }}
            </div>
            <div class="alert alert-danger" v-if="success === false">
                {{ $t("@app:registration.reset_password.failed") }}
            </div>

            <div class="my-4" v-if="success === null">
                <div class="form-group">
                    <label class="col-form-label required" for="reset_password_new_password">
                        {{ $t("@app:my.new_password") }}
                    </label>
                    <div class="col-form-control">
                        <input
                            type="password"
                            id="reset_password_new_password"
                            class="form-control"
                            required
                            v-model="newPassword"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-form-label required" for="reset_password_repeat_password">
                        {{ $t("@app:my.new_password_repeat") }}
                    </label>
                    <div class="col-form-control">
                        <input
                            type="password"
                            id="reset_password_repeat_password"
                            class="form-control"
                            required
                            v-model="newPasswordRepeat"
                        />
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between mt-3">
                <button type="button" class="btn btn-secondary" @click="navbarState.openCard('login')">
                    {{ $t("login.back") }}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary btn-raised"
                    :disabled="newPassword !== newPassword || !newPassword || success"
                >
                    {{ $t("crud:button.save") }}
                </button>
            </div>
        </div>
    </form>
</template>
